import { clamp } from "lodash";

export const getSkewedScore = (score: number): number => {
  const maxValue = 0.85;
  const skewedScore = clamp(score, 0, maxValue) / maxValue;
  return skewedScore;
};
